import jwtDecode from "jwt-decode";
import { Roles } from "../interfaces/Roles";

const getJwtInfo = (value: string | null): any =>
  (value && jwtDecode<Roles>(value)) || {};

export const getRolesFromJwt = (value: string | null): string[] =>
  getJwtInfo(value)?.roles || [];

export const getUserIdFromJwt = (value: string | null): string =>
  getJwtInfo(value)?.user_id || "";
